// src/hooks/usePageContent.js
import { useState } from "react";
import {
    getPackages
} from "../services/paymentService";

const useSellerPackage = () => {
    const [status, setStatus] = useState("idle"); // idle | loading | done | error
    const [error, setError] = useState("");
    const [data, setData] = useState([]);
    const [single, setSingle] = useState(null);

    const fetchPackage = async () => {
        setStatus("loading");
        setError("");

        try {
            const response = await getPackages();

            if (response?.status !== "Error") {
                setData(response.data ?? response); // depending on API shape
                setStatus("done");
            } else {
                setStatus("error");
                setError(response?.message || "Something went wrong");
            }
        } catch (err) {
            setStatus("error");
            setError(err?.message || "Something went wrong");
        }
    };



    const resetStatus = () => {
        setStatus("idle");
        setError("");
    };

    return {
        fetchPackage,
        data,
        single,
        status,
        error,
        resetStatus,
    };
};

export default useSellerPackage;
